import { Box } from '@mui/material';
import { CtaLink } from '@repo/segment/components/CtaLink';
import { LinkType } from '@repo/segment/enums';
import type { BankingOffer } from '@repo/supergraph/marketplace/types';

export const HeaderImageTitleWrapper = ({
  marketplaceEntity,
  children,
  index,
  shouldNotDisplayCta = false,
}: {
  marketplaceEntity: BankingOffer;
  children: React.ReactNode;
  index: number;
  shouldNotDisplayCta?: boolean;
}) => {
  const analyticsPayload = {
    index,
    institutionId: marketplaceEntity.institution.id,
    offerId: marketplaceEntity.id,
    productId: marketplaceEntity.product.id,
    productType: marketplaceEntity.productType,
    monetizable: marketplaceEntity.monetizable,
  };

  if (!marketplaceEntity?.cta || shouldNotDisplayCta) {
    return <Box sx={{ textDecoration: 'none' }}>{children}</Box>;
  }

  return (
    <CtaLink
      cta={marketplaceEntity.cta}
      monetizable={analyticsPayload.monetizable}
      analyticsPayload={analyticsPayload}
      linkType={LinkType.PRODUCT_IMAGE}
      sx={{ cursor: 'pointer', textDecoration: 'none' }}
    >
      {children}
    </CtaLink>
  );
};
